export default __webpack_public_path__ + "static/media/premier-league-banner-cn.96b0f46c.webp";